<!-- 
Contents of the PDF tab of the invoice page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      :nav-url="getNavUrl('pdf')"
      arrived-from-listing
      user-guide-topic="levy-collection-invoices"
      module="invoices"
    >
      <template v-if="arrivedFromLevyCollection" v-slot:navigator >
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :invoice-id="invoiceId" :levy-collection-id="invoice.levyCollectionId" :provider-id="invoice.providerId" path="pdf">
      <v-btn :href="`/api/invoices/${invoiceId}/pdf`" color="primary" flat target="_blank">
        Show invoice PDF in new window
        <v-icon class="ml-2">open_in_new</v-icon>
      </v-btn>
      <div v-if="smAndUp" style="min-height: 100px">
        <v-progress-circular
          indeterminate
          color="primary"
          style="position:absolute;z-index:1;left:150px; top: 150px;"
        />
        <embed
          v-if="invoiceUrl" 
          :src="invoiceUrl"
          type="application/pdf" width="100%" height="700"
          style="position:relative;z-index:2;"
        >
      </div>
    </tabs>
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";
import invoiceMixins from "./mixins";

export default {
  name: "InvoicePdf",
  components: { Tabs, LevyCollectionNavigator },
  mixins: [invoiceMixins],
  data() {
    return { invoiceUrl: "" };
  },
  computed: {
    smAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    }
  },
  watch: {
    invoiceId() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.invoiceUrl = "";
      this.$nextTick(async function() {
        this.invoiceUrl = `/api/invoices/${this.invoiceId}/pdf`;
      });
    }
  }
};
</script>
